import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';
import { FetchedPhotos } from '../types/fetch-models';

const reviewsPhotosFeatureSelector = createFeatureSelector('reviewsPhotos');

export const getReviewsPhotosAllData = createSelector(
  reviewsPhotosFeatureSelector,
  (reviewPhotos): FetchedPhotos[] => {
    const pages = reviewPhotos?.reviewGallery ?? [];
    const reviewPhotoList = pages.flatMap((page) => page.reviewPhotoList ?? []);
    return reviewPhotoList.flatMap((item) =>
      (item.photos ?? []).map((photo) => ({
        ...photo,
        reviewId: item.review.id,
      })),
    );
  },
);

export const getReviewsPhotosPagesCount = createSelector(
  reviewsPhotosFeatureSelector,
  (slice): number => (slice?.reviewGallery?.length ?? 0) + 1,
);

export const getReviewsPhotosLoading = createSelector(
  reviewsPhotosFeatureSelector,
  (slice): boolean => slice?.loading ?? false,
);

export const getHasMoreReviewsPhotos = createSelector(reviewsPhotosFeatureSelector, (slice): boolean => {
  const pages = slice?.reviewGallery ?? [];
  if (!pages.length) {
    return true;
  }

  const last = pages[pages.length - 1];
  const { page, totalPages } = last.meta;
  const lastList = last.reviewPhotoList ?? [];
  const lastCount = lastList.length;

  if (lastCount === 0) {
    return false;
  }

  return page < totalPages;
});
